import SnackbarProvider from './SnackbarProvider'
export type { SnackbarProviderProps } from './SnackbarProvider'
export default SnackbarProvider
